module.exports = __webpack_public_path__ + "img/funnel-fdisp-aggiustata-plus10-2022.59f4f14e.svg";